export default __webpack_public_path__ + "static/media/phone-receiver.ab7c7b79.png";